import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Item from './Item'

interface Props {
  name: string
  colors: string[]
  field: Field
}

const ColorPicker = (props: Props) => {
  const { colors, name, field } = props

  return (
    <Box flexDirection="row">
      {colors.map((color, index) => (
        <Item key={index} field={field} name={name} color={color} />
      ))}
    </Box>
  )
}

export default observer(ColorPicker)
